@if (ShowEnvLabel) {
  <span
    class="env-label position-fixed rounded-bottom"
    [ngStyle]="{'background-color': getBackgroundColor(), 'color': getTextColor()}">
    <small>{{ EnvironmentName }}</small>
  </span>
}